/**
 * Logic to determine is "No Search Suggestions" message appears in enhanced SAYT
 * @param  {Object} state                         Redux state
 * @param  {String} searchTerm                    The search term entered by the user
 * @param  {Object} enhancedSaytSearchResultsData Data object that is sent as first parameter
 *                                                to enhancedSaytSearchResults action
 * @return {Boolean}                              true, if message should be shown, false otherwise
 */
export function shouldShowNoResultsMessage(state, searchTerm, enhancedSaytSearchResultsData) {
    const hasDefaultTrending = !_.isEmpty(_.get(state, 'core.sayt.header.defaultTrending'));
    const hasKeywords = !_.isEmpty(_.get(enhancedSaytSearchResultsData, 'keywords'));
    const newDataHasDefaultTrending = !_.isEmpty(_.get(enhancedSaytSearchResultsData, 'defaultTrending'));
    const isSearchTermEmpty = _.isEmpty(searchTerm);

    if ((hasDefaultTrending || newDataHasDefaultTrending) && isSearchTermEmpty) {
        return false;
    }

    return !hasKeywords && isSearchTermEmpty;
}

/**
 * Function to determine the appropriate data to send off in a GA event
 * @param  {Object} selectedElement               Element from click event handler
 * @param  {String} suggestionType                Options: 'popular', 'product', 'trending', or 'autocomplete'
 */
export function getSaytEventLabel(selectedElement, suggestionType) {
    if (suggestionType === 'product' || suggestionType === 'popular') {
        // if "popular" or "product", "event_label" = the product slug selected
        const slug = $(selectedElement).closest('[data-product-slug]')
                                          .attr('data-product-slug');
        return _.isEmpty(slug) ? false : slug;

    } else if (suggestionType === 'trending' || suggestionType === 'autocomplete') {
        // if "trending" or "autocomplete", "event_label" = the term selected
        const term = _.get($(selectedElement), '0.innerText', false);
        return _.isEmpty(term) ? false : term.trim();
    }
    return false;
}
